<template>
  <div class="left-toolbar-wrapper">
    <nav ref="scrollEl" class="left-toolbar" data-figma-node="2742:7096" aria-label="Editing tools" tabindex="-1">
      <div class="left-toolbar__header">
        <span class="left-toolbar__title">TOOLS</span>
      </div>
      <div class="left-toolbar__primary">
        <NewStudioToolButton label="Select" icon="/new-studio/icons/select.svg" :active="gridStore.selectedTool === SELECTABLE_TOOLS.SELECT" :pressed="gridStore.selectedTool === SELECTABLE_TOOLS.SELECT" :disabled="!hasShapes" @click="actions.select" />
        <NewStudioToolButton label="Lasso" icon="/new-studio/icons/lasso.svg" :active="gridStore.selectedTool === SELECTABLE_TOOLS.LASSO" :pressed="gridStore.selectedTool === SELECTABLE_TOOLS.LASSO" :disabled="!hasShapes" @click="actions.lasso" />
      </div>
      <div class="left-toolbar__divider" role="separator" />
      <div class="left-toolbar__history">
        <NewStudioToolButton label="Undo" icon="/new-studio/icons/undo.svg" :disabled="!hasUndo" @click="actions.undo" />
        <NewStudioToolButton label="Redo" icon="/new-studio/icons/redo.svg" :disabled="!hasRedo" @click="actions.redo" />
        <NewStudioToolButton label="Delete" icon="/new-studio/icons/delete.svg" :disabled="!hasSelection" @click="actions.deleteSelected" />
        <NewStudioToolButton label="Copy" icon="/new-studio/icons/copy.svg" :disabled="!hasSelection" @click="actions.copy" />
        <NewStudioToolButton label="Cut" icon="/new-studio/icons/cut.svg" :disabled="!hasSelection" @click="actions.cut" />
      </div>
      <div class="left-toolbar__divider" role="separator" />
      <div class="left-toolbar__arrange">
        <NewStudioToolButton label="To Front" icon="/new-studio/icons/to-front.svg" :disabled="!canArrange" @click="actions.toFront" />
        <NewStudioToolButton label="To Back" icon="/new-studio/icons/to-back.svg" :disabled="!canArrange" @click="actions.toBack" />
      </div>
    </nav>
    <VerticalScrollIndicators :target="scrollEl" label="editing tools" />
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from 'vue'
import { SELECTABLE_TOOLS } from '~/composables/grid/constants'
import VerticalScrollIndicators from './VerticalScrollIndicators.vue'

const scrollEl = shallowRef<HTMLElement | null>(null)

const actions = useNewStudioActions()
const { canArrange, hasRedo, hasSelection, hasShapes, hasUndo } = actions
const gridStore = useGridStore()
</script>

<style scoped>
.left-toolbar-wrapper {
  position: relative;
  width: var(--studio-left-rail-width, 88px);
  height: 100%;
  min-height: 0;
}

.left-toolbar {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding: 4px 0 16px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-padding-block: 38px;
  border-right: 1px solid var(--studio-shell-border);
  background: var(--studio-surface);
  scrollbar-width: thin;
  scrollbar-color: #ccd5da transparent;
}

.left-toolbar::-webkit-scrollbar {
  width: 5px;
}

.left-toolbar::-webkit-scrollbar-track {
  background: transparent;
  margin: 4px 0;
}

.left-toolbar::-webkit-scrollbar-thumb {
  background-color: #ccd5da;
  border-radius: 3px;
}

.left-toolbar::-webkit-scrollbar-thumb:hover {
  background-color: #b8c6ce;
}

.left-toolbar__header {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 0 6px;
}

.left-toolbar__title {
  color: #5f5e59;
  font-family: var(--studio-font-family);
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1.04px;
  line-height: 17px;
  text-transform: uppercase;
  user-select: none;
}

.left-toolbar__primary,
.left-toolbar__history,
.left-toolbar__arrange {
  display: flex;
  width: 100%;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.left-toolbar__divider {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.left-toolbar__divider::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: var(--studio-shell-border, #e7e6e1);
}

.left-toolbar :deep(.studio-tool) {
  width: 88px;
  height: 72px;
}
</style>
